import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-full">
                  <i className="ri-heart-pulse-line text-lg text-background-50"></i>
                </div>
                <span className="font-heading text-xl text-background-50">
                  羞羞视频
                </span>
              </div>
              <p className="text-foreground-400 text-sm leading-relaxed">
                汇聚全网最热门的趣味搞笑与情感类短视频内容，涵盖恋爱日常、甜蜜互动、搞怪萌宠等多元题材，让你每天都能找到有趣视频，轻松解压、畅享欢乐时光。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-background-50 text-base mb-4">热门分类</h4>
              <ul className="space-y-2">
                {categories.slice(0, 5).map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-foreground-400 hover:text-background-50 text-sm transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-background-50 text-base mb-4">快速链接</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="text-foreground-400 hover:text-background-50 text-sm transition-colors whitespace-nowrap cursor-pointer">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/category/lianai-richang" className="text-foreground-400 hover:text-background-50 text-sm transition-colors whitespace-nowrap cursor-pointer">
                    视频分类
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-foreground-400 hover:text-background-50 text-sm transition-colors whitespace-nowrap cursor-pointer">
                    关于我们
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-background-50 text-base mb-4">关注我们</h4>
              <p className="text-foreground-400 text-sm mb-4">
                获取最新视频更新和精彩推荐
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 text-background-100 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 text-background-100 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 text-background-100 transition-colors cursor-pointer" aria-label="抖音">
                  <i className="ri-tiktok-line text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 text-background-100 transition-colors cursor-pointer" aria-label="B站">
                  <i className="ri-bilibili-line text-lg"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-foreground-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-foreground-500 text-xs">
              &copy; {currentYear} 羞羞视频精选合集 版权所有
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-foreground-500 hover:text-background-100 text-xs transition-colors whitespace-nowrap cursor-pointer">
                隐私政策
              </a>
              <a href="#" className="text-foreground-500 hover:text-background-100 text-xs transition-colors whitespace-nowrap cursor-pointer">
                服务条款
              </a>
              <a href="#" className="text-foreground-500 hover:text-background-100 text-xs transition-colors whitespace-nowrap cursor-pointer">
                联系我们
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}